import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import React from 'react';
import { PhoneInputWithCountryCode } from '@shared/components/PhoneInputWithCountryCode';
import { PhoneNumberValue } from '../../../../../lib/phoneValidation';
import S from '../styles';

export const PhoneNumber = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  errorMessage,
  isDisabled,
}: UseControllerProps<T> & { errorMessage?: string; isDisabled?: boolean }) => (
  <S.PhoneNumber>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => (
        <S.FieldWrapper>
          <PhoneInputWithCountryCode
            value={value as PhoneNumberValue | undefined}
            onChange={onChange}
            disabled={isDisabled}
            errorMessage={errorMessage}
            label="Telefon"
          />
        </S.FieldWrapper>
      )}
    />
  </S.PhoneNumber>
);
